import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { Card, CardBody, CardTitle, FormGroup, Input, Label } from "reactstrap";
import { McInput } from "../../../../../../components";
import {
  IGKDekontamineringAvRomResultater,
  IGKRapport,
} from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";

const DekontamineringAvRom: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKDekontamineringAvRomResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4">Dekontaminering av rom</CardTitle>
        <div className="w-50 mt-4">
          <b>Utført syklus:</b>
          <div>
            <FormGroup className="d-flex flex-column" check>
              <Label check>
                <Input
                  type="radio"
                  checked={data.inndata.utfoertSyklus === true}
                  onChange={() => onUpdateEditData("testResultater.dekontamineringAvRom.inndata.utfoertSyklus", true)}
                />
                Utført
              </Label>
              <Label check>
                <Input
                  type="radio"
                  checked={data.inndata.utfoertSyklus === false}
                  onChange={() => onUpdateEditData("testResultater.dekontamineringAvRom.inndata.utfoertSyklus", false)}
                />
                Ikke utført
              </Label>
            </FormGroup>
          </div>
        </div>
        <div className="d-flex flex-column mt-4">
          <b>Fyll inn syklusstart &#40;-&#41;:</b>
          <McInput
            value={data.inndata.syklusstart}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.syklusstart", e.target.value)
            }
            type="time"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <b>Fyll inn syklusslutt &#40;-&#41;:</b>
          <McInput
            value={data.inndata.syklusslutt}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.syklusslutt", e.target.value)
            }
            type="time"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <b>Fyll inn høyeste PPM &#40;partikler/million&#41;:</b>
          <McInput
            value={data.inndata.hoeyestePPM}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.hoeyestePPM", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <b>Fyll inn luftfuktighet &#40;%&#41;:</b>
          <McInput
            value={data.inndata.luftfuktighet}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.luftfuktighet", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <b>
            Fyll inn temperatur &#40;C<sup>o</sup>&#41;:
          </b>
          <McInput
            value={data.inndata.temperatur}
            onBlur={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvRom.inndata.temperatur", Number(e.target.value))
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer docxImageTag="dekontamineringAvRom" title="Plassering av sensor" />
          <div className="w-50">
            <b>Kommentar:</b>
            <McInput
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.dekontamineringAvRom.inndata.kommentar", e.target.value)
              }
              type="textarea"
              dynamicHeight={true}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DekontamineringAvRom;
